define('src/plugins/backbone.subrouter',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
], function(
    // Libs
    _, Backbone, Mustache, U
) {

    var _result = _.result;

    var SubRouter = Backbone.Router.extend({
        constructor: function(prefix, opt) {
            opt = opt || {};

            this.prefix = prefix = prefix || "";
            if (!_.isEmpty(prefix)) {
                this.prefix = prefix.slice(-1) !== '/' ? prefix + '/' : prefix;
            }
            this.url = { root: opt.url || this.prefix || "", };
            _.each(this.subRoutes, function(value, key) {
                this.url[key] = this.url.root + value;
            }, this);

            this.auth = _result(this, "auth", {});

            SubRouter.__super__.constructor.apply(this, arguments);
        },

        // requires auth by default?
        authDefault: false,

        getPrefix: function(key, replaceHash) {
            if (_.isUndefined(key)) return this.prefix;
            return Mustache.render(this.prefix + this.subRoutes[key], replaceHash);
        },

        hasAuth: function(callbackName) {
            return _result(this.auth, callbackName, this.authDefault);
        },

        isCatchAll: function(route) {
            return route.slice(0, 1) === '*';
        },

        _bindRoutes: function() {
            if (!this.routes) return;
            this.routes = _result(this, 'routes');

            _.each(this.routes, function(callbackName, route) {
                var prefix = this.prefix,
                    url = (this.isCatchAll(route) ? prefix.slice(0, -1) + '(/)' : prefix) + route;

                // U.log("binding route ->", url);
                this.route(url, callbackName);
            }, this);

        },

        checkAuth: _.noop,

        _executeCallback: function(callback, args, name) {
            this.trigger.apply(this, ['before:route:' + name].concat(args));
            this.trigger('before:route', name, args);
            Backbone.history.trigger('before:route', this, name, args);
            callback.apply(this, args);
        },

        execute: function(callback, args, name) {
            if (!callback) return;
            if (this.hasAuth(name)) {
                if (this.checkAuth()) {
                    this._executeCallback(callback, args, name);
                } else {
                    return false;
                }
            } else {
                this._executeCallback(callback, args, name);
            }
        },

        redirect: function(route, options) {
            return SubRouter.__super__.redirect.call(this, "#/" + route, options);
        },

    });

    return SubRouter;

});

